module.exports = __webpack_public_path__ + "img/mobileqr-img.2534511d.svg";